import { render, staticRenderFns } from "./Teaching.vue?vue&type=template&id=417f5b40&scoped=true"
import script from "./Teaching.vue?vue&type=script&lang=js"
export * from "./Teaching.vue?vue&type=script&lang=js"
import style0 from "./Teaching.vue?vue&type=style&index=0&id=417f5b40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417f5b40",
  null
  
)

export default component.exports